var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { confirmCheckoutEligibility, checkout } from "../checkoutUtils";
import { OrderFlowErrorMessages } from "../../OrderFlow/hooks/Session/useSession";
export const checkoutFormSubmit = (setLoading, flowSku, paymentProcessor, paymentIntentId, showModal, toast, navigate, giftCardState, resetCheckoutContext, resetBillingInfoContext, resetOrderFlowContext, goBackToOrderFlow, isMobileOrder, paymentMethodFieldValue, initPayWithPaymentMethod, mobileRedirectSuccessUrl, mobileRedirectFailureUrl) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    setLoading(true);
    const checkoutModel = {
        giftCardInfo: {
            fromFirstName: giftCardState.fromFirstName,
            fromLastName: giftCardState.fromLastName,
            giftMessage: giftCardState.message,
            toEmail: giftCardState.email,
            toFirstName: giftCardState.toFirstName,
            toLastName: giftCardState.toLastName,
            initialValue: giftCardState.amount,
            isVirtual: true,
            orderNumber: "neworder",
            deliveryDate: moment(giftCardState.deliveryDate).format("YYYY-MM-DD"),
            paymentAmount: giftCardState.amount,
        },
        checkoutInfo: {
            PaymentMethodId: data.paymentMethod,
        },
        skipPayment: false,
    };
    const res = yield confirmCheckoutEligibility("gift", checkoutModel);
    const { data: { success }, } = res;
    if (!success) {
        goBackToOrderFlow(flowSku, (_a = res.data.responseMsg) !== null && _a !== void 0 ? _a : OrderFlowErrorMessages.PROCESSING_ORDER);
        return;
    }
    const skipPayment = false;
    checkout(setLoading, toast, navigate, showModal, resetCheckoutContext, resetBillingInfoContext, resetOrderFlowContext, flowSku, isMobileOrder, skipPayment, paymentMethodFieldValue, initPayWithPaymentMethod, paymentProcessor, checkoutModel, paymentIntentId, data.paymentMethod.toString(), mobileRedirectSuccessUrl, mobileRedirectFailureUrl);
});
